import { ScribeLayout } from '@/components/layout/scribe-layout';
import CommunityTemplateDetails from '@/container/community/details';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

const CommunityTemplateDetailsPage = () => {
  const { isAuthenticated } = useIsAuthenticated();

  if (isAuthenticated) {
    return (
      <ScribeLayout>
        <CommunityTemplateDetails />
      </ScribeLayout>
    );
  }
  return <CommunityTemplateDetails />;
};

export default CommunityTemplateDetailsPage;
